import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { WhyChoose } from "@/components/WhyChoose";
import { Comparison } from "@/components/Comparison";
import { HowItWorks } from "@/components/HowItWorks";
import { Footer } from "@/components/Footer";
import { Privacy } from "@/pages/Privacy";
import { Terms } from "@/pages/Terms";

const Landing = () => (
    <>
        <Navbar />
        <main>
            <Hero />
            <Marquee />
            <WhyChoose />
            <Comparison />
            <HowItWorks />
        </main>
        <Footer />
    </>
);

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="min-h-screen overflow-x-clip bg-[#050505] font-sans text-white antialiased">
            <div className="noise-overlay" aria-hidden="true" />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
